import { num } from '@/lib/format';
import type { Rag } from '@/types/models';

interface StatTileProps {
  label: string;
  value: number | string | null | undefined;
  unit?: string;
  sub?: string;
  rag?: Rag;
  decimals?: number;
  large?: boolean;
}

/** A single KPI readout. Values arrive from the server already calculated -
 *  this component formats, it never computes. */
export function StatTile({ label, value, unit, sub, rag, decimals = 0, large }: StatTileProps) {
  // One formatter for the whole app - see lib/format.ts.
  const display =
    value === null || value === undefined || value === ''
      ? '—'
      : typeof value === 'number'
        ? num(value, decimals)
        : value;

  const ragClass = rag && rag !== 'grey' ? ` stat--${rag}` : '';

  return (
    <div className={`stat${ragClass}`}>
      <span className="stat__label">{label}</span>
      <span className={`stat__value${large ? ' stat__value--lg' : ''}`}>
        {display}
        {unit && display !== '—' && <span className="stat__unit">{unit}</span>}
      </span>
      {sub && <span className="stat__sub">{sub}</span>}
    </div>
  );
}
